import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { registerViewFilterFunction } from './registerViewNotification';
import { useSavedFiltersContext } from '@ecosystem/newron-core';

const NEW_FILTER_URL_PARAM = 'filterId';

const M2_PATH = /\/mi|\/ml|\/mo/;
const DP_PATH = /\/dpi|\/dpl|\/dpo/;
const PL_ANALYSE_PATHS = /ml\/products\/analyse/;

function deleteFilterParam() {
  const url = new URL(window.location.href);
  const urlSearchParams = url.searchParams;
  urlSearchParams.delete(NEW_FILTER_URL_PARAM);
  url.search = urlSearchParams.toString();
  history.replaceState({}, '', url.href);
}

function ViewSavedFilterHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const urlFilterId = searchParams.has(NEW_FILTER_URL_PARAM) ? searchParams.get(NEW_FILTER_URL_PARAM) : null;
  const { setNewFilterId } = useSavedFiltersContext();

  // register view filter function
  useEffect(() => {
    const viewFilterFunction = filterData => {
      const isMarket2Page = Boolean(window.location.pathname.match(M2_PATH));
      const isAnalysePage = Boolean(window.location.pathname.match(PL_ANALYSE_PATHS));
      const isDpPage = Boolean(window.location.pathname.match(DP_PATH));

      if ((!isMarket2Page && !isDpPage) || isAnalysePage) {
        navigate(`/mo?filterId=${filterData.filterId}`);
      } else {
        setNewFilterId(filterData.filterId);
      }
    };

    registerViewFilterFunction(viewFilterFunction);
  }, [navigate, setNewFilterId]);

  // write filter id from the url to the saved filter context
  useEffect(() => {
    const isMarket2Page = Boolean(window.location.pathname.match(M2_PATH));
    if (isMarket2Page && urlFilterId) {
      setNewFilterId(urlFilterId);
      deleteFilterParam();
    }
  }, [urlFilterId, setNewFilterId]);

  return null;
}

export { ViewSavedFilterHandler };
